import { format } from 'date-fns'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useOrganizationsAPI } from 'src/API/central.organizationAPI'
import { useUserCapacityAPI, useUserWorkItemsAPI } from 'src/API/central.usersAPI'
import { InputStandard } from 'src/components/standard.input'
import { TablePlater } from 'src/components/standard.table'
import { TypographyLead, TypographyStandardP1, TypographyStandardTitleH2 } from 'src/components/typography'
import { stringToColor } from 'src/lib/utils'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'src/shadcn/ui/accordion'
import { ProjectComponent } from './component.projectCard'
import { useSelector } from 'react-redux'
import { RootState } from 'src/redux/store'
import { useCentralAPI } from 'src/API/centralAPI'
// import { ImportExcelModal } from './component.importExcelModal'






export function MyWorksPage() {


    const user = useSelector((state: RootState) => state.user.adminDetails)

    const {
        centralData
    } = useCentralAPI({
        trigger: false
    })

    //find origin id of user form centeral data
    const centralUser = centralData?.Users.find((usercentral) => {
        return usercentral.user.mailAddress === user?.emailAddress
    });

    const { listOrganizations } = useOrganizationsAPI()
    const [datefilter, setDatefilter] = useState<{
        fromDate?: string,
        toDate?: string
    }>({
        fromDate: format(new Date().setDate(new Date().getDate() - 28), 'yyyy-MM-dd'),
        toDate: undefined
    })


    const organizations = listOrganizations()
    const [filters, setFilters] = useState<{
        organizationIds?: string[],
        workItems?: 'completed' | 'inProgress' | 'all',
        sortBy?: 'uncompletedFirst' | 'completedFirst' | 'sortByName'
    }>({
        organizationIds: organizations.map(organization => organization.accountId),
        workItems: 'all',
        sortBy: 'completedFirst'
    })

    const {
        UserWithCapacity,
        isFetching,
        isLoading
    } = useUserWorkItemsAPI(
        {
            filters: {
                workItems: filters.workItems === 'all' ? undefined : filters.workItems,
                organizationIds: filters.organizationIds,

            },
            sortBy: filters.sortBy,
            fromDate: datefilter.fromDate,
            toDate: datefilter.toDate,
            userOriginId: centralUser?.user.originId!
        }
    )




    return (
        <div className=' grow  flex flex-col overflow-auto'>

            <TablePlater className=' flex flex-col gap-2'>
                {/* Buttons section */}
                <div className=' flex justify-start w-full gap-4 max-w-[300px] '>

                    <InputStandard
                        title='from date'
                        value={datefilter.fromDate} onChange={(e) => setDatefilter({ ...datefilter, fromDate: e.target.value })} type='date' />
                    <InputStandard
                        title='to date'
                        value={datefilter.toDate} onChange={(e) => setDatefilter({ ...datefilter, toDate: e.target.value })} type='date' />
                </div>
                {
                    isLoading || !UserWithCapacity ? (

                        Array.from({ length: 5 }).map((_, i) => (
                            <div key={i} className=' flex items-center justify-center h-20 w-full bg-white shadow-md border animate-pulse '>
                            </div>
                        ))

                    ) : null
                }

                {UserWithCapacity ? <Accordion value='item-1' onDoubleClick={() => { console.log('double clicked') }} key={UserWithCapacity?.user.originId} type="single" collapsible className="w-full relative">
                    <AccordionItem value={'item-1'} >
                        <AccordionTrigger  >
                            {UserWithCapacity?.totalPendingCapacityToday! > 0 && <div className={` 
                                                    w-28 h-6 text-white absolute right-0 top-0 
                                                    flex items-center justify-center text-xs
                                                    rounded-tr-lg rounded-bl-md
                                                    bg-red-500 z-10
                                                    `}>work pending</div>}
                            <div className='grid grid-cols-1  w-full md:grid-cols-5 gap-2 gap-y-4  bg-white'>
                                {/* project status */}
                                <div className='w-full flex items-center gap-2 md:col-span-3  '>
                                    <div
                                        style={{
                                            background: stringToColor(UserWithCapacity?.user.mailAddress!)
                                        }}
                                        className="avatar min-h-12 min-w-12 max-h-12 max-w-12 flex items-center justify-center border rounded-full text-white ">
                                        {UserWithCapacity!.user.displayName.charAt(0).toUpperCase()}
                                    </div>
                                    <div className=' flex flex-col text-start justify-center '>
                                        <TypographyLead>{UserWithCapacity.user.displayName}</TypographyLead>
                                        <TypographyStandardP1 >{UserWithCapacity.user.mailAddress}</TypographyStandardP1>
                                    </div>
                                </div>
                                <div className=' flex col-span-1 md:col-span-2'>
                                    <div className=' flex flex-col w-full place-items-end'>
                                        <div className='flex'>
                                            <TypographyStandardTitleH2>Projects: </TypographyStandardTitleH2>
                                            <TypographyStandardP1>{UserWithCapacity.projects.length}</TypographyStandardP1>
                                        </div>
                                        <div className='flex'>
                                            <TypographyStandardTitleH2>Total Work Item: </TypographyStandardTitleH2>
                                            <TypographyStandardP1>{UserWithCapacity.totalWorkItem}</TypographyStandardP1>
                                        </div>
                                        <div className='flex'>
                                            <TypographyStandardTitleH2>Completed Work Item: </TypographyStandardTitleH2>
                                            <TypographyStandardP1>{UserWithCapacity.completedWorkItem}</TypographyStandardP1>
                                        </div>
                                        <div className='flex'>
                                            <TypographyStandardTitleH2>Capacity today: </TypographyStandardTitleH2>
                                            <TypographyStandardP1>{UserWithCapacity.totalCapacityToday}</TypographyStandardP1>
                                        </div>
                                        <div className='flex'>
                                            <TypographyStandardTitleH2>Pending Capacity today: </TypographyStandardTitleH2>
                                            <TypographyStandardP1>{UserWithCapacity.totalPendingCapacityToday}</TypographyStandardP1>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </AccordionTrigger>
                        <AccordionContent>
                            <div className=' flex flex-col gap-1 max-h-[90vh] overflow-auto'>
                                {UserWithCapacity.activeProjects.map(
                                    project => {

                                        return (
                                            <ProjectComponent
                                                TotalWorkItem={project.userTotalWorkItems}
                                                completedWorkItem={project.userCompletedWorkItems}
                                                key={project.id}
                                                projectName={project.name}
                                                totalTeam={project.teams}
                                                totalTodayCapacity={project.totalTodayCapacity}
                                                totalPendingCapacityToday={project.totalPendingCapacityToday}
                                            />
                                        )
                                    }
                                )}
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                </Accordion> : null}




            </TablePlater>
        </div>
    )

}



